// Copyright (c) Hamilton Manufacturing Corp.
import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { generateId } from '../api/utility';
import { FormContext } from './Form';

const Row = styled.label`
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
`;
const Wrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0.25em 0.5em;
    transition: 0.3s;
`;
const CheckboxCSS = styled.label`
	cursor: ${({ disabled }) => disabled ? 'default' : 'pointer'};
	width: 2em;
	height: 1em;
	background: ${({ theme }) => theme.input.CBBackground};
	display: flex;
    align-items: center;
	border-radius: 100px;
	position: relative;
    transition: 0.5s;

    &:after {
        content: '';
        position: absolute;
        left: 2%;
        width: 0.8em;
        height: 0.8em;
        background: #fff;
        border-radius: 90px;
        transition: 0.3s;
    }
    &:hover:after {
        width: 0.9em;
        height: 0.9em;
    }
    &:active:after {
        width: 0.7em;
        height: 0.7em;
    }
`;
const InputCSS = styled.input`
    display: none;
    cursor: inherit;

    &:checked + label {
        background:  ${({ theme }) => theme.input.active};
    }
    &:checked + label:after {
        left: 52%;
    }
    &:disabled + label:after {
        background: ${({ theme }) => theme.input.disabled};
    }
`;
const MinContent = styled.div`
    margin: 0 0.5em;
`;

const CheckBox = ({ ...props }) => {
    const id = generateId();
    const { onClick, ...otherProps } = props;

    return (
        <Row>
            {props.label &&
                <MinContent>
                    {props.label}
                </MinContent>
            }
            <Wrapper>
                {
                    props.standalone ?
                        <InputCSS type="checkbox" id={id} {...props} /> :
                        <FormCheckBox id={id} {...props} />
                }
                <CheckboxCSS htmlFor={id}  {...otherProps} />
            </Wrapper>
        </Row>
    );
}

const FormCheckBox = ({ ...props }) => {
    const { values, submitting, editing, setValues, setErrors } = useContext(FormContext);

    const [disable, setDisable] = useState(false);
    const [firstRun, setFirstRun] = useState(true);

    // useEffect(() => {
    //     if (!props.disabledcondition) return;
    //     setDisable(values[props.disabledcondition]);
    //     if (values[props.disabledcondition]) {
    //         setInvalidation(false)
    //     } else {
    //         // setInvalidation(true)
    //     }
    // }, [values])

    useEffect(() => {
        if (firstRun) {
            setFirstRun(false)
            return;
        }

        setDisable(values[props.disabledcondition]);

        if (!props.disabledcondition) return;
        if (values[props.disabledcondition]) {
            setInvalidation(false)
        } else {
            // handleChange(values[name])
        }
    }, [values[props.disabledcondition]])

    const handleChange = (e) => {
        setValues({
            ...values,
            [props.name]: e
        })
    }

    const setInvalidation = (invalid) => {
        setErrors(v => {
            return {
                ...v,
                [props.name]: invalid
            }
        });
    }

    return (
        <InputCSS
            type='checkbox'
            checked={values[props.name]}
            onChange={(e) => handleChange(e.target.checked)}
            disabled={props.disabled || submitting || !editing || disable}
            {...props}
        />
    );
}

export default CheckBox;